// material
import { Container, Stack, Typography, Paper,InputAdornment, Tabs, Tab, TextField, Alert, Pagination } from '@mui/material'
import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Page from '../components/Page'
import Loader from './Loader'
import settings from '../config/settings';
import md5 from "md5";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

var axiosInstance = axios.create()
// ----------------------------------------------------------------------

export default function ExternalReport({reportUrl}) {

  const [chartData,setChartData] = useState(null)
  const action = "get_user_info_by_uuid"
  const apikey = "D21B2DBA59F52167BEBFF2484DAFB"
  const checksum =  "e24ff4dd97b431813fe9d7b12d389860"
  const URL = "https://dev-apigateway.extramarks.com/cognito-login-service/auth/getUserInfoByUuid"

  const websiteKey = 'D21B2DBA59F52167BEBFF2484DAFB'
  const websiteMsaSalt = 'CoLo&Mi!2021'

  const search = useLocation().search;
  const uuid = new URLSearchParams(search).get('uuid');


  const getChecksum = (action, username, password) => {
    const loginParam = action + ":" + websiteKey + ":" + username + ":" + password + ":" + websiteMsaSalt

    console.log("loginParam:::",loginParam)
    let checksum = md5(
      action +
      ":" +
      websiteKey +
      ":" +
      username +
      ":" +
      password +
      ":" +
      websiteMsaSalt
    );
    return checksum
  }



  useEffect( async () => {

    try {
      const  WEBSITE_LOGIN_DATA = { "action": "cognito_login", "apikey":"D21B2DBA59F52167BEBFF2484DAFB","checksum": "97b237346453464fe0c7ad879fa2ae86","login_details": { "username":"guestam", "password": "Password@123", "app_name": "Student_App", "acess_id":"", "app_version": "", "gcm_key": "", "email_address": "", "latitude": "", "longitude": "","operating_system_version": "", "source": "website" } }

      let checkSumParams = "get_user_info_by_uuid:" + apikey + ":" + "5a3980c9-73db-4d19-8f27-f5d38d97621c" + ":" + websiteMsaSalt;

      const REQUEST_BODY = {
      "action": action,
      "apikey": apikey,
      "checksum": md5(checkSumParams),
      //"uuid": uuid
      "uuid": "5a3980c9-73db-4d19-8f27-f5d38d97621c"
    }

      let loginResponse = await axiosInstance.post(`https://dev-apigateway.extramarks.com/cognito-login-service/auth/login`, WEBSITE_LOGIN_DATA)
      console.log("loginResponse",loginResponse);
      const { access_token } = loginResponse?.data
      if(access_token) {
        localStorage.setItem('website_access_token',access_token)
        axiosInstance.post(URL, REQUEST_BODY, {
          headers: {
                'Authorization': 'Bearer ' + access_token,
                'token': access_token
          }
        })
        .then((response) => {
            console.log("response data:::",response)
            if(response?.status === 200) {
              const data = response?.data;
              setChartData(data)
            }
        })
        .catch((error) => {
          console.log("error:::",error)
        })
      }
    }
    catch (err) {
    if(err.response && err.response.data){
      throw err.response.data
    }
    else{
      throw err
    }
  }
  },[uuid])


  return (
    <TableContainer component={Paper} style={{maxWidth:'100%',margin: 'auto',
    padding:'20px'}}>
      <Table style={{maxWidth:'650px'}} aria-label="simple table">
        <TableHead>
          <TableRow>
            {
              chartData && Object.keys(chartData).length && Object.keys(chartData).map(keys => (
                   <TableCell key={keys} align="right">{keys}</TableCell>
              ))
            }
            </TableRow>
        </TableHead>
        <TableBody>
            <TableRow >
              {
              chartData && Object.values(chartData).length && Object.values(chartData).map(val => (
                   <TableCell key={val} align="right">{val}</TableCell>
              ))
            }
            </TableRow>
  
        </TableBody>
      </Table>
    </TableContainer>
  )
}
